import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { decimal, validString } from "Components/shared/helpers/validations";

export const VehicleTypeFormSchema = Yup.object().shape(
  reverseShape({
    _id: validString.optional(),
    name: validString.required(),
    engineType: validString.required(),
    capacity: decimal.required(),
    maxWeight: decimal.required(),
    maxDimension: decimal.required(),
    emissionFactor: decimal.required(),
  }),
);
